<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.projects.loadingProjects">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <v-flex xs12 v-if="listView">
      <v-card hover>
        <v-data-table
          :items="filteredProjects"
          :headers="headers"
          :rows-per-page-items="itemsPerPageOptions"
        >
          <template slot="items" slot-scope="props">
            <table-row :headers="headers" :row="props.item" parent="Project" :key="props.item.id"></table-row>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <transition-group name="data-list" tag="layout-no-padding" v-else>
      <v-flex
        xs12
        sm6
        md4
        xl3
        v-for="(project,i) in filteredProjects"
        :key="project.id"
        class="data-list-item"
      >
        <project-card :project="project" :index="i"></project-card>
      </v-flex>
    </transition-group>
  </transition>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ProjectService from "@/services/requests/projectService";
import ProjectCard from "@/components/projects/projectCard";
import TableRow from "@/components/ui/masterFileTableRow";
export default {
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Active?",
          align: "center",
          value: "active"
        },
        {
          text: "Client",
          align: "right",
          value: "client.name"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false
        }
      ]
    };
  },
  methods: {
    deleteProject(i, project) {
      ProjectService.deleteProject(project.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("projects/deleteProject", project);
        })
        .catch(err => {
          //console.log("An error occured");
        });
    }
  },
  computed: {
    sortBy: Store.getSet({ store: "projects", prop: "sortBy" }),
    filterBy: Store.getSet({ store: "projects", prop: "filterBy" }),
    listView: Store.getSet({ store: "projects", prop: "listView" }),
    projects: Store.getSet({ store: "projects", prop: "projects" }),
    client: Store.getSet({ store: "projects", prop: "client" }),
    clientFilteredProjects() {
      if (!!this.client) {
        return this.projects.filter(project => {
          return project.clientId == this.client;
        });
      } else {
        return this.projects;
      }
    },
    sortedProjects() {
      if (this.sortBy) {
        var path = this.sortBy;
        return this.clientFilteredProjects.sort((a, b) => {
          //if(a[property] < b[property])
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == "updatedAt") {
              return 1;
            }
            return -1;
          } else {
            if (path == "updatedAt") {
              return -1;
            }
            return 1;
          }
        });
      } else {
        return this.clientFilteredProjects;
      }
    },
    filteredProjects() {
      return this.sortedProjects.filter(project => {
        return (
          project.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
        );
      });
      //return this.sortedProjects;
    }
  },
  components: {
    ProjectCard,
    TableRow
  }
};
</script>

<style scoped>
</style>
